const STORAGE_PREFIX = "segmentUsersImportUploadId:";
const IDENTIFIER_COLUMNS = ["profile_id", "user_id", "national_id"];

export const getLastSegmentUploadId = (segmentId) => {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${segmentId}`);
  } catch {
    return null;
  }
};

export const saveLastSegmentUploadId = (segmentId, uploadId) => {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${segmentId}`, uploadId);
  } catch {
    // storage unavailable; status just won't persist across reopen
  }
};

export const clearLastSegmentUploadId = (segmentId) => {
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${segmentId}`);
  } catch {
    // storage unavailable; nothing to clear
  }
};

const readAsText = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });

const CASE_HINT = "Column names must be lowercase, for example";

/**
 * Reads only the first line of the file and checks the header has an `action`
 * column and at least one identifier column. Names are matched exactly (the
 * backend is case sensitive). Returns an error message, or null when the
 * header is valid.
 */
export const validateSegmentCsvHeader = async (file) => {
  const text = await readAsText(file.slice(0, 4096));
  const firstLine = text.replace(/^\uFEFF/, "").split(/\r?\n/)[0] || "";
  const columns = firstLine.split(",").map((c) => c.trim().replace(/^"|"$/g, ""));
  const lowerColumns = columns.map((c) => c.toLowerCase());

  if (!columns.includes("action")) {
    return lowerColumns.includes("action")
      ? `${CASE_HINT} "action".`
      : 'The header row must include an "action" column.';
  }
  if (!IDENTIFIER_COLUMNS.some((c) => columns.includes(c))) {
    return IDENTIFIER_COLUMNS.some((c) => lowerColumns.includes(c))
      ? `${CASE_HINT} "profile_id".`
      : "The header row must include at least one of profile_id, user_id or national_id.";
  }
  return null;
};
